
export function setupTracing(){
    window['_sc_whoami'] = whoami;

    let _sc_query = window.location.search;
    let _sc_href = window.location.href;
    window['_sc_query'] = _sc_query;
    window['_sc_href'] = _sc_href;

    // WPLM reload workaround
    if(window.location.search.indexOf('gclid') !== -1 ||window.location.search.indexOf('msclkid') !== -1 ){
        if (history.pushState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.pushState({path:newurl},'',newurl);
        }
    }
    function setPageUserData() {
        var u = JSON.parse(this.responseText);
        var ev = new CustomEvent('userdata', {detail: {
                userData: u
            }});
        window['_sc_user_data'] = u;
        window.dispatchEvent(ev);
    }

    whoami("pv", {}, setPageUserData);

    document.addEventListener("DOMContentLoaded", function() {
        setupPageMetrics();
    });
}

export function whoami(ev, data={}, reqListener){
    const req = new XMLHttpRequest();
    if(reqListener) {
        req.addEventListener("load", reqListener);
    }
    req.open("POST", "/frontend/whoami");
    req.setRequestHeader("x-ev", ev);
    req.setRequestHeader("x-referer", window['_sc_href']);
    req.setRequestHeader("x-page-referer", document.referrer);
    req.setRequestHeader("x-query", window['_sc_query']);
    req.setRequestHeader("x-iw", "" + window.innerWidth);
    req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    req.send(JSON.stringify(data));
}


function setupPageMetrics(){
    const onScrollToEl = window['onScrollToEl'];

    const tracedElements = document.querySelectorAll('[data-whoami]');
    tracedElements.forEach(function(element) {
        const traceSpec = element.dataset.whoami;
        const traceId = element.dataset.whoamiId;
        if(!traceId){
            console.log("no id for el");
            return;
        }
        const traces = traceSpec.split(",");
        for(let tr of traces){
            tr = tr.trim();
            switch (tr) {
                case "first-scroll":
                    onScrollToEl(element, function(){
                        whoami('pi', {action: 'first-scroll',  element: traceId} )
                    });
                    break;
                case "first-hover":
                    element.addEventListener("mouseover", function(event) {
                        whoami('pi', {action: 'first-hover',  element: traceId} )
                    }, {once: true});
                    break;
                case "click":
                    element.addEventListener("click", function(event) {
                        whoami('pi', {action: 'click',  element: traceId} )
                    });
                    break;
            }
        }
    });
}